<template>
  <v-dialog v-model="isOpen" scrollable max-width="1000px">
    <v-card>
      <v-card-text>
        <v-flex>
          <v-card>
            <v-card-text class="font-weight-bold">
              <v-layout row wrap>
                <v-flex xs12>
                  <span>Product Code :</span>
                  <v-chip>
                    <span>{{ wsDetail.productCode }}</span>
                  </v-chip>
                  <span>Product Name :</span>
                  <v-chip>
                    <span>{{ wsDetail.productName }}</span>
                  </v-chip>
                  <span>Factor/Unit :</span>
                  <v-chip>
                    <span>{{ wsDetail.factorUnitName }}</span>
                  </v-chip>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex class="mt-1">
          <v-card>
            <v-data-table
              :headers="headers"
              :items="wsItemDetailList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.stockInDateInMilliSeconds | format-ms-date-time }}</td>
                <td>{{ props.item.batchNo }}</td>
                <td>{{ props.item.qcNo }}</td>
                <td>
                  {{ props.item.mfgDateInMilliSeconds | formatMsDate }}
                </td>
                <td>
                  {{ props.item.expDateInMilliSeconds | formatMsDate }}
                </td>
                <td>{{ props.item.qty | decFormat(6) }}</td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "WholeSaleDetailItemDialog",
  props: {
    showDialog: Boolean,
    wholesaleItems: Array,
    wsDetail: Object,
  },
  data: () => ({
    showListLoading: false,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "",
      totalItems: 0,
    },
    totalRows: 0,
    rowsPerPageItems: [25, 50, 100],
    headers: [
      { text: "Stock In Date", sortable: false },
      { text: "Batch No", sortable: false },
      { text: "QC No", sortable: false },
      { text: "MFG Date", sortable: false },
      { text: "EXP Date", sortable: false },
      { text: "Qty", sortable: false },
    ],
  }),

  computed: {
    isOpen: {
      get() {
        return this.showDialog;
      },
      set() {
        this.$emit("close");
      },
    },
    wsItemDetailList() {
      return this.wholesaleItems.filter((item) => {
        if (item && this.wsDetail) {
          return (
            item.productCode == this.wsDetail.productCode &&
            item.factorUnitName == this.wsDetail.factorUnitName &&
            item.isFOC == this.wsDetail.isFOC
          );
        }
      });
    },
  },
};
</script>
